<template>
<div>
  <user-status style='padding: 1px 0px;'
    @selected='visible=!visible'
    :with-dropdown='groups && groups.length > 0'
    :practitioner='currentUser' ></user-status>

  <transition name='slide' >
    <v-card>
      <grouped-practitioner-picker
        :groups='groups'
        :withActivate='false'
        @selected='triggerBecome'
        v-show='visible' >
      </grouped-practitioner-picker>
    </v-card>
  </transition>

  <v-dialog v-model="dialog" max-width="290">
    <v-card >
      <v-card-title class="headline text-xs-center">
        {{ $t('message.switching') }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class='text-xs-center' >
          <v-progress-circular
            v-if='requestStatus !== 200'
            color='amber'
            :size='70' :indeterminate='true' ></v-progress-circular>
          <v-icon v-else :size='70' color='green' >check_circle</v-icon>
          <p v-if='status === "switching"' class='subheading' >
            {{ $t( 'message.progress', {user: currentUser.first_name} ) }}
          </p>
          <p v-else-if='status === "success"' class='subheading' >
            {{ $t( 'message.success', {user: currentUser.first_name} ) }}
          </p>

      </v-card-text>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import UserStatus from '@/components/auth/UserStatus'
import GroupedPractitionerPicker from '@/components/pickers/GroupedPractitionerPicker'

export default {
  name: 'AccountSwitcher',
  components: {GroupedPractitionerPicker, UserStatus},
  props: {
    value: { type: Object, default: () => { return {} } },
    groups: { type: Array, default: () => { return [] } }
  },
  data () {
    return {
      visible: false,
      dialog: false,
      status: null,
      currentUser: {},
      originalUser: {},
      reqId: 'become-request'
    }
  },
  watch: {
    value () {
      if (this.value) {
        this.currentUser = this.value
      }
    },
    requestStatus () {
      if (this.requestStatus === 200) {
        this.status = 'success'
        this.$emit('became', this.request.result.data)
        let vm = this
        setTimeout(() => {
          vm.dialog = false
          vm.status = null
        }, 2000)
      }
    }
  },
  methods: {
    triggerBecome (practitioner) {
      this.currentUser = practitioner
      // this.$emit('input', this.currentUser)
      this.dialog = true
      this.status = 'switching'
      let data = {
        become_id: practitioner.id
      }
      this.$multiguru.resource('become').id(this.reqId).create(data)
    }
  },
  computed: {
    request () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    requestStatus () {
      return this.request.status
    }
  },
  i18n: {
    messages: {
      en: {
        message: {
          switching: 'Switching Accounts',
          progress: 'Logging in as {user}',
          success: 'You are now logged in as {user}'
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// AccountSwitcher.vue?6f2d7f24